import getStore from '../store/sharingStore';
import SharingPermissionItemState from '../store/schema/SharingPermissionItemState';
import { addCalendarSharingPermission } from '../actions/calendarSharing';
import { mutator } from 'satcheljs';
import calendarStrings from 'owa-strings/owa-calendar-strings';
import { format } from 'owa-strings';

export default mutator(addCalendarSharingPermission, msg => {
    let viewState = getStore().viewState;
    let sharingPermissionItem: SharingPermissionItemState = msg.sharingPermission;

    if (!viewState || !sharingPermissionItem) {
        return;
    }

    let isInsideOrg =
        sharingPermissionItem.IsInsideOrganization &&
        sharingPermissionItem.CurrentDetailLevel != 'Delegate';
    let isDelegate =
        sharingPermissionItem.IsInsideOrganization &&
        sharingPermissionItem.CurrentDetailLevel == 'Delegate';
    let isOutsideOrg = !sharingPermissionItem.IsInsideOrganization;
    sharingPermissionItem.isPending = false;

    if (isInsideOrg && viewState.peopleInsideOrg) {
        viewState.peopleInsideOrg.push(sharingPermissionItem);
    } else if (isOutsideOrg && viewState.peopleOutsideOrg) {
        viewState.peopleOutsideOrg.push(sharingPermissionItem);
    } else if (isDelegate && viewState.delegates) {
        viewState.delegates.push(sharingPermissionItem);
    }

    viewState.userActionAriaLabel = format(
        calendarStrings.shareSuccessAriaLabel,
        sharingPermissionItem.EmailAddress ? sharingPermissionItem.EmailAddress.Name : ''
    );

    viewState.selectedRecipientPermission = null;
});
